import type { Appointment } from './types'

/**
 * Check if an appointment is a test appointment based on the customer email
 * Test appointments have email addresses ending with '@enter.de'
 */
export const isTestAppointment = (appointment: Appointment | null | undefined): boolean => {
  return appointment?.customerEmail?.endsWith('@enter.de') ?? false
}

/**
 * A pv-only marketplace appointment never has a data-collection form
 * submission — completing it just marks `dataCollected` true so it stops
 * showing up as pending, without any actual submission for appointly's
 * viewer to show. Used to hide the "View" link, which would otherwise point
 * at nothing.
 */
export const isPvOnly = (appointment: Appointment | null | undefined): boolean => {
  return (
    appointment?.type === 'marketplace' &&
    appointment.subtypes?.length === 1 &&
    appointment.subtypes[0] === 'pv'
  )
}
